import Hera1 from '../../media/hera/hera.png'
import Hera2 from '../../media/hera/hera1.png'

const images =[
    Hera1,Hera2
]

export default images;